import { render, staticRenderFns } from "./ConfigLevel.vue?vue&type=template&id=23633672&scoped=true&"
import script from "./ConfigLevel.vue?vue&type=script&lang=js&"
export * from "./ConfigLevel.vue?vue&type=script&lang=js&"
import style0 from "./ConfigLevel.vue?vue&type=style&index=0&id=23633672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23633672",
  null
  
)

export default component.exports